module.exports = __webpack_public_path__ + "static/btn_old.49832f94.png";